/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSaveOutsideMarkets = () =>
  useMutation({
    mutationKey: ["saveOutsideMarkets"],
    mutationFn: outsideMarket => {
      let api__data = {
        reportDate: outsideMarket.reportDate,
        regionId: outsideMarket.regionId,
        productLineId: outsideMarket.productLineId,
        title: outsideMarket.title,
        content: outsideMarket.content,
        headerImagePath: outsideMarket.headerImagePath,
        id: outsideMarket.id
      }
      return service.saveOutsideMarket(api__data)
    },
  });

export default useSaveOutsideMarkets;
